module.exports = __webpack_public_path__ + "img/Pack Station (WMS Module)_Page_22.0780bb74.jpg";